import { FC } from "react";
import { LottieProps as ReactLottieProps } from "react-lottie";
import LottiePlayer from "react-lottie-player";
import { cx } from "../cx";

interface LottieProps extends ReactLottieProps {
  className?: string;
}

export const Lottie: FC<LottieProps> = ({
  className,
  options: { animationData, loop, autoplay, rendererSettings },
  height,
  width,
  style,
  isStopped,
  eventListeners,
}) => (
  <div className={cx("flex justify-center", className)}>
    <LottiePlayer
      animationData={animationData}
      loop={loop}
      style={{ height, width, ...style }}
      play={isStopped ? false : (autoplay ?? true)}
      rendererSettings={rendererSettings}
      onComplete={
        eventListeners?.find((listener) => listener.eventName === "complete")
          ?.callback
      }
    />
  </div>
);
